import React, { useContext } from "react";
import { Plan } from "../../../@types";
import { AnalyticsActionType } from "../../../app/contexts/Analytics/types";
import { AppContext } from "../../../app/store";
import { useTranslate } from "../../../helpers";
import { addProtocolToUrl } from "../../../helpers/objectUtilities";

export const DoctorServicesTableCaption: React.FunctionComponent<{
  plan: Plan;
}> = ({ plan }) => {
  const t = useTranslate();
  const { dispatch } = useContext(AppContext);
  return (
    <div className="mct-c-table__caption-col--1">
      <h3 className="mct-c-table__caption-title">
        {t("plan_terms.doctor_services")}
      </h3>
      <a
        href={addProtocolToUrl(plan.provider_network_web_address || plan.url)}
        target="_blank"
        rel="noopener noreferrer"
        className="preview-disable-exempt"
        onClick={(): void => {
          dispatch({
            type: AnalyticsActionType.SEND_TEALIUM_EVENT,
            settings: {
              event_action: "Plan Details",
              event_label: "View Provider Network Directory",
            },
          });
        }}
      >
        {t("plan_terms.view_provider_network_directory")}
      </a>
    </div>
  );
};
